module.exports = "<!-- <app-container></app-container> -->\r\n\r\n<router-outlet></router-outlet>\r\n<toaster-container [toasterconfig]=\"config\"></toaster-container>\r\n<app-loading-spinner></app-loading-spinner>\r\n<app-sales-manager-dashboard></app-sales-manager-dashboard>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main